import store from '../Store/index';

const student_routes = [
  {
    path: '/student-list',
    component: () => import('../Pages/Student/StudentList.vue'),
    name: 'StudentList',
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    },
    meta: {
      requiresAuth: true,
      part: 'students'
    }
  },
  {
    path: '/student-print-list',
    component: () => import('../Pages/Prints/StudentListPrint.vue'),
    name: 'StudentListPrint',
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    },
    meta: {
      requiresAuth: true,
      part: 'students'
    }
  },
  {
    path: '/service-order-print',
    component: () => import('../Pages/Prints/ServiceOrderPrint.vue'),
    name: 'ServiceOrderPrint',
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    },
    meta: {
      requiresAuth: true,
      part: 'students'
    }
  },
  {
    path: '/home-visit-blank',
    component: () => import('../Components/Blanks/HomeVisit/BlankPage.vue'),
    name: 'HomeVisit',
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    },
    meta: {
      requiresAuth: true,
      part: 'students'
    }
  },
  {
    path: '/chat',
    component: () => import('../Pages/Chat.vue'),
    name: 'Chat',
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/calendar',
    component: () => import('../Pages/Calendar.vue'),
    name: 'VueCal',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/centers/:slug/day',
    component: () => import('../Pages/StudyCenterNew/StudyCenterNew.vue'),
    name: 'StudyCenterNew',
    meta: {
      requiresAuth: true,
      part: 'study-center'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/student-schedule',
    component: () => import('../Pages/StudyCenterNew/ReproachesSchedule.vue'),
    name: 'ReproachesSchedule',
    meta: {
      requiresAuth: true,
      part: 'study-center'
    }
  },
  {
    path: '/student-security',
    component: () => import('../Pages/StudentPages/SecurityStudent.vue'),
    name: 'SecurityStudent',
    meta: {
      requiresAuth: true,
      part: 'students'
    }
  },
  {
    path: '/document-editor',
    component: () => import('../Pages/StudyCenterNew/DocumentEditor.vue'),
    name: 'DocumentEditor',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/centers/:slug/week',
    component: () => import('../Pages/StudyCenterNew/StudyCenterNewWeek2.vue'),
    name: 'StudyCenterNewWeek',
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/board-draw',
    component: () => import('../Pages/BoardDraw.vue'),
    name: 'BoardDraw',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mobile-dashbord',
    component: () => import('../Pages/MobileDashbord.vue'),
    name: 'MobileDashbord',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/new-student-list',
    component: () => import('../Pages/NewStudent/NewStudentList.vue'),
    name: 'NewStudentList',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/graduated-student-list',
    component: () =>
      import('../Pages/GraduatedStudent/GraduatedStudentList.vue'),
    name: 'GraduatedStudentList',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/deleted-student-list',
    component: () => import('../Pages/DeletedStudent/DeletedStudentList.vue'),
    name: 'DeletedStudentList',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/students-security',
    component: () => import('../Pages/Security/TeacherPermits'),
    name: 'StudentsSecurity',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/scan-page',
    component: () => import('../Pages/Security/Blocks/QRScanTab.vue'),
    name: 'QRScanTab',
    meta: {
      requiresAuth: true,
      part: 'security'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/scan-select',
    component: () => import('../Pages/Security/Blocks/ScanSelectPage.vue'),
    name: 'ScanSelectPage',
    meta: {
      requiresAuth: true,
      part: 'security'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/controllers',
    component: () => import('../Pages/Security/Blocks/Controllers.vue'),
    name: 'Controllers',
    meta: {
      requiresAuth: true,
      part: 'security'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/students-security-print',
    component: () => import('../Pages/Prints/TeacherPermitsPrint'),
    name: 'StudentsSecurity',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/kicked-student-list',
    component: () => import('../Pages/KickedStudent/KickedStudentList.vue'),
    name: 'KickedStudentList',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/dashboard/:id',
    component: () => import('../Pages/MainDashboard.vue'),
    name: 'MainDashboard',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/student-dashboard/:id',
    component: () => import('../Pages/Student/StudentDashboard.vue'),
    name: 'StudentDashboard',
    meta: {
      requiresAuth: true,
      part: 'students',
      layout: 'student-layout'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/student-behavior/:id',
    component: () => import('../Pages/Student/StudentBehavior.vue'),
    name: 'StudentBehavior',
    meta: {
      requiresAuth: true,
      part: 'students',
      layout: 'student-layout'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/student-reproaches-tab/:id',
    component: () => import('../Pages/Student/StudentReproachesTab.vue'),
    name: 'StudentReproachesTab',
    meta: {
      requiresAuth: true,
      part: 'students',
      layout: 'student-layout'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/student-boarding-school/:id',
    component: () => import('../Pages/Student/StudentCenter.vue'),
    name: 'StudentCenter',
    meta: {
      requiresAuth: true,
      part: 'students',
      layout: 'student-layout'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },

  {
    path: '/student-project/:id',
    component: () => import('../Pages/Student/StudentProject.vue'),
    name: 'StudentProject',
    meta: {
      requiresAuth: true,
      part: 'students',
      layout: 'student-layout'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/student-school/:id',
    component: () => import('../Pages/Student/StudentSchool.vue'),
    name: 'StudentSchool',
    meta: {
      requiresAuth: true,
      part: 'students',
      layout: 'student-layout'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/student-add',
    component: () => import('../Pages/Student/StudentAdd.vue'),
    name: 'StudentAdd',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/parent-blank',
    component: () =>
      import('../Pages/Student/Blocks/StudentBehavior/ParentBlank.vue'),
    name: 'ParentBlank',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/new-blank-1/:id',
    component: () =>
      import('../Pages/BehaviorBlank/StuffBlank/newStuffBlank.vue'),
    name: 'NewBlank1',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/new-blank-2/:id',
    component: () => import('../Pages/BehaviorBlank/PlanBlank/PlanBlank.vue'),
    name: 'NewBlank2',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/plan-blank-allStudents',
    component: () =>
      import('../Pages/BehaviorBlank/PlanBlank/PlanBlankAllStudents.vue'),
    name: 'PlanBlank',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/plan-blank/:id/blank',
    component: () =>
      import('../Pages/BehaviorBlank/PlanBlank/ViewPlanBlank.vue'),
    name: 'ViewPlanBlank',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/nuclear-stuff-blank/:id/blank',
    component: () =>
      import('../Pages/BehaviorBlank/StuffBlank/ViewStuffBlank.vue'),
    name: 'ViewStuffBlank',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/nuclear-stuff-blank-tables',
    component: () => import('../Pages/BehaviorBlank/StuffBlankTables.vue'),
    name: 'StuffBlankTables',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/plan-blank-tables',
    component: () => import('../Pages/BehaviorBlank/PlanBlankTables.vue'),
    name: 'PlanBlankTables',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/nuclear-stuff-blank-all-student',
    component: () =>
      import('../Pages/BehaviorBlank/StuffBlank/StuffBlankAllStudent.vue'),
    name: 'ViewStuffBlankAll',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/personal-conversation-blank',
    component: () =>
      import('../Pages/Student/Blocks/StudentBehavior/PCBlank.vue'),
    name: 'PersonalConversationBlank',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/feedback-blank',
    component: () =>
      import('../Pages/Student/Blocks/StudentBehavior/FeedbackBlank.vue'),
    name: 'FeedbackBlank',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/assessment-blank',
    component: () =>
      import('../Pages/Student/Blocks/StudentBehavior/AssessmentBlank.vue'),
    name: 'AssessmentBlank',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/incident-blank',
    component: () =>
      import('../Pages/Student/Blocks/StudentBehavior/IncidentBlank.vue'),
    name: 'IncidentBlank',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/commission-blank',
    component: () =>
      import('../Pages/Student/Blocks/StudentBehavior/CommissionBlank.vue'),
    name: 'CommissionBlank',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/exit-permission-blank',
    component: () =>
      import('../Pages/Student/Blocks/StudentBehavior/ExitPermissionBlank.vue'),
    name: 'ExitPermissionBlank',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/exit-permission-blank/:id',
    component: () =>
      import('../Pages/Student/Blocks/StudentBehavior/ExitPermissionBlank.vue'),
    name: 'ExitPermissionBlankId',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },

  {
    path: '/student-data/:id/',
    component: () => import('../Pages/Student/StudentEdit.vue'),
    name: 'StudentEdit',
    meta: {
      requiresAuth: true,
      part: 'students',
      layout: 'student-layout'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/incident-blank-view',
    component: () =>
      import('../Pages/Student/Blocks/BlankView/IncidentBlankView.vue'),
    name: 'IncidentBlankView',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/centers/:slug/students-report',
    component: () => import('../Pages/Reports/Day.vue'),
    name: 'ReportsDay',
    meta: {
      requiresAuth: true,
      part: 'study-center'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/dashboard-of-all-projects',
    component: () => import('../Pages/Reports/NewDashboard.vue'),
    name: 'NewDashboard',
    meta: {
      requiresAuth: true,
      part: 'projects'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/reports',
    component: () => import('../Pages/Reports/Layout.vue'),
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    },
    children: [
      {
        path: '',
        component: () => import('../Pages/Reports/Reports.vue'),
        name: 'Reports',
        meta: {
          requiresAuth: true,
          part: 'students'
        },
        beforeEnter: (to, from, next) => {
          if (store.state.auth.user.entity_id === 2) {
            next({ name: 'ReproachesSchedule' });
          } else {
            next();
          }
        }
      },
      {
        path: 'template',
        component: () => import('../Pages/Reports/Template.vue'),
        name: 'ReportsTemplate',
        meta: {
          requiresAuth: true,
          part: 'students'
        },
        beforeEnter: (to, from, next) => {
          if (store.state.auth.user.entity_id === 2) {
            next({ name: 'ReproachesSchedule' });
          } else {
            next();
          }
        }
      },
      {
        path: 'dashboard',
        component: () => import('../Pages/Reports/Dashboard.vue'),
        name: 'ReportsDashboard',
        meta: {
          requiresAuth: true,
          part: 'students'
        },
        beforeEnter: (to, from, next) => {
          if (store.state.auth.user.entity_id === 2) {
            next({ name: 'ReproachesSchedule' });
          } else {
            next();
          }
        }
      }
    ]
  },
  {
    path: '/reports-year',
    component: () => import('../Pages/ReportYear.vue'),
    name: 'ReportYear',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  }
];
const blank_pdf_routes = [];
const study_center_new = [
  {
    path: '/study-center-new',
    component: () => import('../Pages/StudyCenterNew/StudyCenterNew.vue'),
    name: 'StudyCenterTemplate',
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  }
];
const study_center = [
  {
    path: '/lessons-all-students',
    component: () =>
      import('../Pages/StudyCenterNew/ReproachesAllStudents.vue'),
    name: 'ReproachesAllStudents',
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/centers/:slug/template',
    component: () => import('../Pages/StudyCenter/Template.vue'),
    name: 'StudyCenterTemplate',
    meta: {
      requiresAuth: true,
      part: 'study-center'
    }
  },
  {
    path: '/centers/:slug/month',
    component: () => import('../Pages/StudyCenter/Month.vue'),
    name: 'StudyCenterMonth',
    meta: {
      requiresAuth: true,
      part: 'study-center'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  // {
  //   path: '/centers/:slug/week',
  //   component: () => import('../Pages/StudyCenter/Week.vue'),
  //   name: 'StudyCenterWeek',
  //   meta: {
  //     requiresAuth: true,
  //     part: 'study-center'
  //   }
  // },
  {
    path: '/study-center/student-week',
    component: () => import('../Pages/StudyCenter/StudentWeek.vue'),
    name: 'StudyCenterStudentWeek',
    meta: {
      requiresAuth: true,
      part: 'study-center'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/centers/:day/day',
    component: () => import('../Pages/StudyCenter/Day.vue'),
    name: 'StudyCenterDay',
    meta: {
      requiresAuth: true,
      part: 'study-center'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/centers/:slug/pdf',
    component: () => import('../Pages/StudyCenterNew/Blocks/DayPdf.vue'),
    name: 'StudyCenterDayPDF',
    meta: {
      requiresAuth: true,
      part: 'study-center',
      layout: 'lessons-pdf'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/study-center/new-day',
    component: () => import('../Pages/StudyCenter/NewDay.vue'),
    name: 'StudyCenterNewDay',
    meta: {
      requiresAuth: true,
      part: 'study-center'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/centers/:slug/reports',
    component: () => import('../Pages/StudyCenter/Report/Layout.vue'),
    meta: {
      requiresAuth: true,
      part: 'study-center'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    },
    children: [
      {
        path: '',
        component: () => import('../Pages/StudyCenter/Report/Month.vue'),
        name: 'ReportMonth',
        meta: {
          requiresAuth: true,
          part: 'study-center'
        },
        beforeEnter: (to, from, next) => {
          if (store.state.auth.user.entity_id === 2) {
            next({ name: 'ReproachesSchedule' });
          } else {
            next();
          }
        }
      },
      {
        path: '',
        component: () => import('../Pages/StudyCenter/Report/RuleReport.vue'),
        name: 'RuleReport',
        meta: {
          requiresAuth: true,
          part: 'study-center'
        },
        beforeEnter: (to, from, next) => {
          const slug = to.params.slug;
          if (store.state.auth.user.entity_id === 2) {
            next({ name: 'ReproachesSchedule' });
          } else {
            next();
          }
        }
      },
      {
        path: '',
        component: () => import('../Pages/StudyCenter/Report/Week.vue'),
        name: 'ReportWeek',
        meta: {
          requiresAuth: true,
          part: 'study-center'
        },
        beforeEnter: (to, from, next) => {
          if (store.state.auth.user.entity_id === 2) {
            next({ name: 'ReproachesSchedule' });
          } else {
            next();
          }
        }
      }
    ]
  },
  {
    path: '/centers/:slug/reports-week',
    component: () => import('../Pages/StudyCenter/Report/Layout.vue'),
    meta: {
      requiresAuth: true,
      part: 'study-center'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    },
    children: [
      {
        path: '',
        component: () => import('../Pages/StudyCenter/Report/Week.vue'),
        name: 'ReportWeek',
        meta: {
          requiresAuth: true,
          part: 'study-center'
        },
        beforeEnter: (to, from, next) => {
          if (store.state.auth.user.entity_id === 2) {
            next({ name: 'ReproachesSchedule' });
          } else {
            next();
          }
        }
      }
    ]
  }
];
const worker_routes = [
  {
    path: '/projects',
    component: () =>
      import('../Pages/AdministrationProjects/SchoolProjects.vue'),
    name: 'SchoolProjects',
    meta: {
      requiresAuth: true,
      part: 'projects'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/projects-groups',
    component: () =>
      import('../Pages/AdministrationProjects/ProjectsTeamTable.vue'),
    name: 'ProjectsTeamTable',
    meta: {
      requiresAuth: true,
      part: 'projects'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/schedule-of-all-projects',
    component: () =>
      import('../Pages/AdministrationProjects/ScheduleOfAllProjects.vue'),
    name: 'ScheduleOfAllProjects',
    meta: {
      requiresAuth: true,
      part: 'projects'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/report-of-all-projects',
    component: () =>
      import('../Pages/AdministrationProjects/ReportOfAllProjects.vue'),
    name: 'ReportOfAllProjects',
    meta: {
      requiresAuth: true,
      part: 'projects'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/worker-hours-worked',
    component: () =>
      import('../Pages/AdministrationProjects/WorkerHoursWorked.vue'),
    name: 'WorkerHoursWorked',
    meta: {
      requiresAuth: true,
      part: 'projects'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/main-project-info',
    component: () =>
      import('../Pages/AdministrationProjects/MainProjectInfo.vue'),
    name: 'MainProject',
    meta: {
      requiresAuth: true,
      part: 'projects'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/group-info',
    component: () =>
      import('../Pages/AdministrationProjects/MainGroupInfo.vue'),
    name: 'MainGroupInfo',
    meta: {
      requiresAuth: true,
      part: 'projects'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },

  {
    path: '/administration-tables',
    component: () =>
      import('../Pages/AdministrationResours/AdministrationResours.vue'),
    name: 'AdministrationResours',
    meta: {
      requiresAuth: true,
      part: 'administrations'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  // {
  //   path: '/district-administration-management',
  //   component: () =>
  //     import(
  //       '../Pages/AdministrationResours/AdministrationMenagment/AdministrationMenagment.vue'
  //     ),
  //   name: 'AdministrationMenagment',
  //   meta: {
  //     requiresAuth: true,
  //     part: 'workers'
  //   },
  //   beforeEnter: (to, from, next) => {
  //     if (store.state.auth.user.entity_id === 2) {
  //       next({ name: 'ReproachesSchedule' });
  //     } else {
  //       next();
  //     }
  //   }
  // },
  {
    path: '/district-administration-contacts',
    component: () =>
      import(
        '../Pages/AdministrationResours/AdministrationMenagment/Tabs/DistrictAdministrationContacts.vue'
      ),
    name: 'DistrictAdministrationContacts',
    meta: {
      requiresAuth: true,
      part: 'workers'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },

  {
    path: '/institution-info',
    component: () =>
      import(
        '../Pages/AdministrationResours/SchoolMenagment/Tabs/SchoolInfo.vue'
      ),
    name: 'SchoolInfo',
    meta: {
      requiresAuth: true,
      part: 'workers'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },

  {
    path: '/workers-list',
    component: () => import('../Pages/Worker/WorkersList.vue'),
    name: 'WorkersList',
    meta: {
      requiresAuth: true,
      part: 'workers'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/worker-add',
    component: () => import('../Pages/Worker/WorkerAdd.vue'),
    name: 'WorkerAdd',
    meta: {
      requiresAuth: true,
      part: 'workers'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/worker/:id',
    component: () => import('../Pages/Worker/Worker.vue'),
    name: 'Worker',
    meta: {
      requiresAuth: true,
      part: 'workers'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  }
];
const setting_routes = [
  {
    path: '/settings',
    component: () => import('../Pages/Settings/Settings.vue'),
    name: 'Settings',
    meta: {
      requiresAuth: true,
      part: 'settings'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/settings-departments',
    component: () => import('../Pages/Settings/DepartmentList.vue'),
    name: 'DepartmentsList',
    meta: {
      requiresAuth: true,
      part: 'settings'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/settings/roles',
    component: () => import('../Pages/Settings/RoleList.vue'),
    name: 'RolesList',
    meta: {
      requiresAuth: true,
      part: 'settings'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/settings-management-list',
    component: () => import('../Pages/Settings/ManagementList.vue'),
    name: 'ManagementList',
    meta: {
      requiresAuth: true,
      part: 'settings'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  }
];
const auth_routes = [
  {
    path: '/sign-in',
    component: () => import('../Pages/SignIn.vue'),
    name: 'SignIn',
    meta: {
      layout: 'auth-layout'
    }
  },
  {
    path: '/gul/:slug',
    component: () => import('../Pages/StudyCenter/EditLessonPage.vue'),
    name: 'EditLessonPage',
    meta: {
      layout: 'guest-layout'
    }
  },
  {
    path: '/gum/:lesson/:group',
    component: () =>
      import(
        '../Pages/AdministrationProjects/Pages/OpenPageLessonGroupEdit.vue'
      ),
    name: 'OpenPageLessonGroupEdit',
    meta: {
      layout: 'guest-layout'
    }
  },
  {
    path: '/forgot-password',
    component: () => import('../Pages/ForgotPassword.vue'),
    name: 'ForgotPassword',
    meta: {
      layout: 'auth-layout'
    }
  },

  {
    path: '/first-change-password',
    component: () => import('../Pages/FirstChangePassword.vue'),
    name: 'FirstChangePassword',
    meta: {
      layout: 'auth-layout',
      requiresAuth: true
    }
  },
  {
    path: '/reset-password/:token/:email',
    component: () => import('../Pages/ResetPassword.vue'),
    name: 'ResetPassword',
    meta: {
      layout: 'auth-layout'
    }
  },
  {
    path: '/login',
    component: () => import('../Pages/SignIn.vue'),
    name: 'SignIn',
    meta: {
      layout: 'auth-layout'
    }
  },
  {
    path: '/sign-in-confirm',
    component: () => import('../Pages/ConfirmAuth.vue'),
    name: 'Confirm',
    meta: {
      layout: 'auth-layout'
    }
  }
];
const maintenance_routes = [
  {
    path: '/service-orders',
    component: () => import('../Pages/Maintenance/ServiceOrderList.vue'),
    name: 'ServiceOrderList',
    meta: {
      requiresAuth: true,
      part: 'maintenance'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/service-order-old/:order',
    component: () => import('../Pages/Maintenance/ServiceOrder.vue'),
    name: 'ServiceOrderOld',
    meta: {
      requiresAuth: true,
      part: 'maintenance'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/service-order/:order',
    component: () => import('../Pages/Maintenance/ServiceOrderNew.vue'),
    name: 'ServiceOrder',
    meta: {
      requiresAuth: true,
      part: 'maintenance'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  }
];
const security_routes = [
  {
    path: '/security',
    component: () => import('../Pages/Security/Security.vue'),
    meta: {
      requiresAuth: true,
      part: 'security'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    },
    children: [
      {
        path: 'entry',
        component: () => import('../Pages/Security/EntryPermit'),
        name: 'Security',
        meta: {
          requiresAuth: true,
          part: 'security'
        },
        beforeEnter: (to, from, next) => {
          if (store.state.auth.user.entity_id === 2) {
            next({ name: 'ReproachesSchedule' });
          } else {
            next();
          }
        }
      },
      {
        path: 'student',
        component: () => import('../Pages/Security/StudentPermit'),
        name: 'StudentPermit',
        meta: {
          requiresAuth: true,
          part: 'security'
        },
        beforeEnter: (to, from, next) => {
          if (store.state.auth.user.entity_id === 2) {
            next({ name: 'ReproachesSchedule' });
          } else {
            next();
          }
        }
      },
      {
        path: 'student-permission',
        component: () => import('../Pages/Security/StudentPermission'),
        name: 'StudentPermission',
        meta: {
          requiresAuth: true,
          part: 'security'
        },
        beforeEnter: (to, from, next) => {
          if (store.state.auth.user.entity_id === 2) {
            next({ name: 'ReproachesSchedule' });
          } else {
            next();
          }
        }
      },
      {
        path: 'worker-guest-permission',
        component: () => import('../Pages/Security/WorkerGuestPermission'),
        name: 'WorkerGuestPermission',
        meta: {
          requiresAuth: true,
          part: 'security'
        },
        beforeEnter: (to, from, next) => {
          if (store.state.auth.user.entity_id === 2) {
            next({ name: 'ReproachesSchedule' });
          } else {
            next();
          }
        }
      },

      {
        path: 'dashboard',
        component: () => import('../Pages/Security/Dashboard'),
        name: 'PermitDashboard',
        meta: {
          requiresAuth: true,
          part: 'security'
        },
        beforeEnter: (to, from, next) => {
          if (store.state.auth.user.entity_id === 2) {
            next({ name: 'ReproachesSchedule' });
          } else {
            next();
          }
        }
      }
    ]
  },
  {
    path: '/own-permission',
    component: () => import('../Pages/Security/OwnPermits'),
    name: 'OwnPermits',
    meta: {
      requiresAuth: true,
      part: 'own_permits'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  }
];
const blanks_routes = [
  {
    path: '/commission-blanks',
    component: () => import('../Pages/BehaviorBlank/CommissionBlanks.vue'),
    name: 'CommissionBlanks',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/incident-blanks',
    component: () => import('../Pages/BehaviorBlank/IncidentBlanks.vue'),
    name: 'IncidentBlanks',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/personal-conversation-blanks',
    component: () =>
      import('../Pages/BehaviorBlank/PersonalConversationBlanks.vue'),
    name: 'PersonalConversationBlanks',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/assessment-blanks',
    component: () => import('../Pages/BehaviorBlank/AssessmentBlanks.vue'),
    name: 'AssessmentBlanks',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/feedback-blanks',
    component: () => import('../Pages/BehaviorBlank/FeedbackBlanks.vue'),
    name: 'FeedbackBlanks',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/parent-blanks',
    component: () => import('../Pages/BehaviorBlank/ParentBlanks.vue'),
    name: 'ParentBlanks',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  }
];
let routes = [
  {
    path: '/',
    component: () => import('../Pages/HomePage.vue'),
    name: 'HomePage',
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'MobileDashbord' });
      } else {
        next();
      }
    }
  }
];
routes = routes.concat(auth_routes);
routes = routes.concat(student_routes);
routes = routes.concat(study_center);
routes = routes.concat(worker_routes);
routes = routes.concat(maintenance_routes);
routes = routes.concat(setting_routes);
routes = routes.concat(blank_pdf_routes);
routes = routes.concat(blanks_routes);
routes = routes.concat(security_routes);
const all_routes = routes;
// meta:
// requiresAuth: -  only for auth users
// part: -  for header menu
// item: -  for sidebar menu
export default all_routes;
